export default __webpack_public_path__ + "static/media/peter_morley.300388ec.jpg";